import { FaMinus } from '@react-icons/all-files/fa/FaMinus';
import { FaPlus } from '@react-icons/all-files/fa/FaPlus';
import React from 'react';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
import { S } from './style';
export const MinusButton = ({ size, color, isDisabled, onButtonClick }) => (<S.Button disabled={isDisabled} type='button' onClick={onButtonClick} color={color}>
    <FaMinus style={{ fontSize: size, color: SEMANTIC_COLORS.DEFAULT_COUNTER_BUTTON_TEXT }}/>
  </S.Button>);
export const PlusButton = ({ size, color, isDisabled, onButtonClick }) => (<S.Button disabled={isDisabled} type='button' onClick={onButtonClick} color={color}>
    <FaPlus style={{ fontSize: size, color: SEMANTIC_COLORS.DEFAULT_COUNTER_BUTTON_TEXT }}/>
  </S.Button>);
